var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2869 7.89362L17.2868 7.89344C15.4315 4.97789 12.7585 3.35834 10.0003 3.35834C8.61738 3.35834 7.26573 3.7617 6.02122 4.52552C4.7762 5.29798 3.64481 6.43279 2.71371 7.89362H17.2869ZM17.2869 7.89362C17.6414 8.45012 17.8337 9.21177 17.8337 9.99896C17.8337 10.7863 17.6413 11.5452 17.2877 12.0968L17.287 12.0979C16.3559 13.5588 15.2245 14.6937 13.9794 15.4662C12.7349 16.23 11.3833 16.6333 10.0003 16.6333C7.24153 16.6333 4.569 15.0215 2.71416 12.0988L2.71371 12.0981M17.2869 7.89362L2.71371 12.0981M2.71371 12.0981C2.35912 11.5414 2.16699 10.7817 2.16699 9.99584M2.71371 12.0981L2.16699 9.99584M2.16699 9.99584C2.16699 9.21004 2.35909 8.45044 2.71363 7.89374L2.16699 9.99584ZM6.13366 10C6.13366 12.1337 7.85671 13.8667 10.0003 13.8667C12.1439 13.8667 13.867 12.1337 13.867 10C13.867 7.86633 12.1439 6.13334 10.0003 6.13334C7.85671 6.13334 6.13366 7.86633 6.13366 10Z",
    fill: "#86A7C3",
    stroke: "#86A7C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 9.99997C8.125 8.95831 8.96895 8.11664 10 8.11664C11.0322 8.11664 11.8833 8.96778 11.8833 9.99997C11.8833 11.0299 11.0345 11.875 10 11.875C8.96781 11.875 8.125 11.0322 8.125 9.99997Z",
    fill: "#86A7C3",
    stroke: "#86A7C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ef993d58.svg";
export { ForwardRef as ReactComponent };